export default "__VITE_ASSET__sOvC6A$3__"